import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { generateDeepLink, navigateToCommunity } from '../../actions/UseCases';
import DropdownBox from '../../components/Dropdown/DropdownBox';
import DropdownHr from '../../components/Dropdown/DropdownHr';
import Option from '../../components/Dropdown/DropdownOption';
import * as Constants from '../../constants';
import { locationConstants } from '../../constants/DesktopApp';
import { isElectron } from '../../lib/ClientInfoUtils';
import { isDesktopDeepLinkingEnabled } from '../../lib/configuration/TunerVarUtils';
import * as RouteUtils from '../../lib/RouteUtils';

const headerSettings = [
  {
    label: Constants.Nav.messages.myProfile,
    qaTag: Constants.QATags.PMPM,
    pathname: RouteUtils.getProfilePath(),
    showAvatar: true,
  },
  {
    label: Constants.Nav.messages.settings,
    qaTag: Constants.QATags.PSM,
    pathname: RouteUtils.getInfoPath(),
  },
  {
    label: Constants.Nav.messages.help,
    qaTag: Constants.QATags.PHM,
    externalUrl: RouteUtils.getHelpUrl(),
  },
  { label: Constants.Nav.messages.community, qaTag: Constants.QATags.PCM },
  {
    label: Constants.Nav.messages.openInDesktopApp,
    pathname: RouteUtils.getDesktopLandingPath(),
    hideInElectron: true,
    shouldGenerateDeepLink: true,
  },
  { hr: true },
  {
    label: Constants.Nav.messages.signOut,
    qaTag: Constants.QATags.PSOM,
    pathname: RouteUtils.getLogoutPath(),
  },
];

export const HeaderDropdownKey = Symbol('HeaderDropdown');

class HeaderDropdown extends React.Component {
  static propTypes = {
    childProps: PropTypes.object.isRequired,
    closeDropdown: PropTypes.func,
    intl: PropTypes.object,
    navigateToCommunity: PropTypes.func,
    isElectron: PropTypes.bool,
    isDesktopDeepLinkingEnabled: PropTypes.bool,
    generateDeepLink: PropTypes.func,
    sourcePath: PropTypes.string,
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  render() {
    const options = headerSettings.map(
      (
        {
          label,
          qaTag,
          pathname,
          externalUrl,
          showAvatar,
          hr,
          hideInElectron,
          shouldGenerateDeepLink,
        },
        i,
      ) => {
        const isCommunityLink = label === Constants.Nav.messages.community;
        if (hr) {
          return <DropdownHr key={`option${i}`} />;
        }

        const optionProps = {
          callback: () => {
            if (shouldGenerateDeepLink) {
              this.props.generateDeepLink({
                sourcePath: this.props.sourcePath,
                sourceLocation: locationConstants.headerDropDown,
              });
            } else if (this.context.router && pathname) {
              this.context.router.push(pathname);
            } else if (window && externalUrl) {
              window.open(externalUrl);
            } else if (isCommunityLink) {
              this.props.navigateToCommunity(true, {
                action: Constants.Community.EventAction.COMMUNITY_CLICKED_FROM_DROPDOWN,
                view_mode: Constants.Community.ViewMode.PROFILE,
              });
            }
          },
          label: this.props.intl.formatMessage(label),
          key: `option${i}`,
          qaTag,
          closeDropdown: this.props.closeDropdown,
          extrasStyles: ['DropdownOption--header'],
          showAvatar,
          listenerImgUrl: this.props.childProps.listenerImgUrl,
          updateSearchOverlay: this.props.childProps.updateSearchOverlay,
          pathname,
          externalUrl,
        };

        if (!(hideInElectron && this.props.isElectron)) {
          if (
            label === Constants.Nav.messages.openInDesktopApp &&
            !this.props.isDesktopDeepLinkingEnabled
          ) {
            return;
          }
          return <Option {...optionProps} />;
        }
      },
    );
    const props = {
      menuType: HeaderDropdownKey,
    };

    return <DropdownBox {...props}>{options}</DropdownBox>;
  }
}

export function mapStateToProps(state) {
  return {
    isElectron: isElectron(),
    isDesktopDeepLinkingEnabled: isDesktopDeepLinkingEnabled(state),
    sourcePath: RouteUtils.getCurrentPathnameFromState(state) || '',
  };
}

const mapDispatchToProps = {
  navigateToCommunity,
  generateDeepLink,
};

export const constructors = {
  [HeaderDropdownKey]: connect(mapStateToProps, mapDispatchToProps)(injectIntl(HeaderDropdown)),
};
